import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Layout from './components/Layout/Layout'
import HomePage from './pages/HomePage'
import ShopPage from './pages/ShopPage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import ProfilePage from './pages/ProfilePage'
import AuthCallbackPage from './pages/AuthCallbackPage'
import AuthSuccessPage from './pages/AuthSuccessPage'
import AuthErrorPage from './pages/AuthErrorPage'
import LinkDiscordPage from './pages/discord/auth/LinkDiscordPage'
import DiscordGuidelinesPage from './pages/discord/DiscordGuidelinesPage'
import DiscordTermsPage from './pages/discord/DiscordTermsPage'
import DiscordServerSafetyAgeRestrictionPage from './pages/discord/DiscordServerSafetyAgeRestrictionPage'
import DiscordIndexPage from './pages/discord/DiscordIndexPage'
import DiscordViolentExtremismPolicyPage from './pages/discord/safety/DiscordViolentExtremismPolicyPage'
import DiscordHatefulConductPolicyPage from './pages/discord/safety/DiscordHatefulConductPolicyPage'
import DiscordSuicideSelfHarmPolicyPage from './pages/discord/safety/DiscordSuicideSelfHarmPolicyPage'
import DiscordPlatformManipulationPolicyPage from './pages/discord/safety/DiscordPlatformManipulationPolicyPage'
import DiscordDeceptivePracticesPolicyPage from './pages/discord/safety/DiscordDeceptivePracticesPolicyPage'
import DiscordSexualSolicitationPolicyPage from './pages/discord/safety/DiscordSexualSolicitationPolicyPage'
import DiscordIdentityAuthenticityPolicyPage from './pages/discord/safety/DiscordIdentityAuthenticityPolicyPage'
import DiscordReportingAbusiveBehaviorPage from './pages/discord/safety/DiscordReportingAbusiveBehaviorPage'
import { AuthProvider } from './contexts/AuthContext'
import { NotificationProvider } from './contexts/NotificationContext'
import ProtectedRoute from './components/Auth/ProtectedRoute'
import NotificationContainer from './components/Notification/NotificationContainer'

function App() {
  const [theme, setTheme] = useState<'light' | 'dark'>('dark')

  useEffect(() => {
    let savedTheme: 'light' | 'dark' = 'dark'
    try {
      if (localStorage.getItem('theme') === 'light') savedTheme = 'light'
    } catch { /* The theme still works when storage is unavailable. */ }
    setTheme(savedTheme)
    document.documentElement.setAttribute('data-theme', savedTheme)
  }, [])

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark'
    setTheme(newTheme)
    try { localStorage.setItem('theme', newTheme) } catch { /* Storage is optional. */ }
    document.documentElement.setAttribute('data-theme', newTheme)
  }

  return (
    <NotificationProvider>
      <AuthProvider>
        <NotificationContainer />
        <Layout theme={theme} toggleTheme={toggleTheme}>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop" element={<ProtectedRoute><ShopPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/auth/success" element={<AuthSuccessPage />} />
          <Route path="/auth/error" element={<AuthErrorPage />} />
          <Route path="/auth/link-discord" element={<ProtectedRoute><LinkDiscordPage /></ProtectedRoute>} />
          <Route path="/discord" element={<DiscordIndexPage />} />
          <Route path="/discord/guidelines" element={<DiscordGuidelinesPage />} />
          <Route path="/discord/terms" element={<DiscordTermsPage />} />
          <Route path="/discord/server-safety/age-restriction" element={<DiscordServerSafetyAgeRestrictionPage />} />
          <Route path="/discord/safety/violent-extremism-policy-explainer" element={<DiscordViolentExtremismPolicyPage />} />
          <Route path="/discord/safety/hateful-conduct-policy-explainer" element={<DiscordHatefulConductPolicyPage />} />
          <Route path="/discord/safety/suicide-self-harm-policy-explainer" element={<DiscordSuicideSelfHarmPolicyPage />} />
          <Route path="/discord/safety/platform-manipulation-policy-explainer" element={<DiscordPlatformManipulationPolicyPage />} />
          <Route path="/discord/safety/deceptive-practices-policy-explainer" element={<DiscordDeceptivePracticesPolicyPage />} />
          <Route path="/discord/safety/sexual-solicitation-policy-explainer" element={<DiscordSexualSolicitationPolicyPage />} />
          <Route path="/discord/safety/identity-authenticity-policy-explainer" element={<DiscordIdentityAuthenticityPolicyPage />} />
          <Route path="/discord/safety/reporting-abusive-behavior-to-discord" element={<DiscordReportingAbusiveBehaviorPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Layout>
      </AuthProvider>
    </NotificationProvider>
  )
}

export default App
